import { CheckCircleIcon, WarningIcon, WarningCircleIcon, XCircleIcon } from '@phosphor-icons/react';

/** Condition grades, best first. */
export const GRADE_ORDER: readonly string[] = ['A', 'B', 'B/C', 'C', 'D'];

/** Badge classes per condition grade; unknown grades have no entry. */
export const GRADE_COLORS: Readonly<Record<string, string>> = {
  A: 'bg-green-100 text-green-800',
  B: 'bg-blue-100 text-blue-800',
  'B/C': 'bg-yellow-100 text-yellow-800',
  C: 'bg-orange-100 text-orange-800',
  D: 'bg-red-100 text-red-800'
};

/** Filled icon for a condition grade, inheriting its colour from the parent. */
export function GradeIcon({ grade, size = 12 }: { grade: string | null; size?: number }) {
  switch (grade) {
    case 'A':
    case 'B':
      return <CheckCircleIcon size={size} weight="fill" />;
    case 'B/C':
      return <WarningIcon size={size} weight="fill" />;
    case 'C':
      return <WarningCircleIcon size={size} weight="fill" />;
    case 'D':
      return <XCircleIcon size={size} weight="fill" />;
    default:
      return <CheckCircleIcon size={size} weight="fill" />;
  }
}
